export default __webpack_public_path__ + "static/DSC_0180-6d043a1c6ae1a0d539b3e2111b50dbed.jpg";